import { Routes } from '../config/routes'

import type { RouteConfig } from '../types'

import { LeaseHome, ProspectsHome } from '../../containers'

import { ManageLayout } from '../layouts/ManageLayout/ManageLayout'
import { ManageGuard } from '../guards/ManageGuard'
import { LeaseAuditHome } from '../../containers/LeaseAuditNew/LeaseAuditHome/LeaseAuditHome'
import { LeaseAuditDetail } from '../../containers/LeaseAuditNew/Detail/LeaseAuditDetail'
import { PropertyAudit } from '../../containers/PropertyAudit/PropertyAudit'
import { RentHome } from '../../containers/Rent/RentHome'
import { LeadHome } from '../../containers/Outbound/Leads/LeadHome'
import { SpreadsheetUploadPage } from '../../containers/Outbound/ProspectList/SpreadsheetUploadPage'
import { CampaignHome } from '../../containers/Outbound/Campaign/CampaignHome'
import { CampaignDetail } from '../../containers/Outbound/Campaign/CampaignDetail/CampaignDetail'
import { CreateCampaign } from '../../containers/Outbound/Campaign/CreateCampaign/CreateCampaign'
import { GuestCardsPage } from '../../containers/Outbound/Campaign/GuestCards/GuestCardsPage'
import { WebToolsPage } from '../../containers/Outbound/WebTools/WebToolsPage'
import { ContractManager } from '../../containers/ContractManager/ContractManager'
import MoveOutManagement from '../../containers/MoveOutManagement/MoveOutManagement'
import { ConcessionsHome } from '../../containers/Concessions/ConcessionsHome'
import { TenantMessagesHome } from '../../containers/TenantMessages'

import { EzManageIntegrationsPage } from '../../containers/EzManageIntegrations/EzManageIntegrationsPage'
import { LeasingSeasonConfigEditorPage } from '../../containers/LeasingSeasonConfig'
import { PropertyEventsHome } from '../../containers/PropertyEvents'
import { LeasingSeasonHome } from '../../containers/LeasingSeason'
import { ManageSeasonsLanding } from '../../containers/LeasingSeason/ManageSeasons/ManageSeasonsLanding'
import { SeasonCampaignsHome } from '../../containers/LeasingSeason/Campaigns/SeasonCampaignsHome'
import { SeasonCampaignDetail } from '../../containers/LeasingSeason/Campaigns/SeasonCampaignDetail'
import { SeasonCampaignCreate } from '../../containers/LeasingSeason/Campaigns/SeasonCampaignCreate'
import {
    SignableDocsCreate,
    SignableDocsDetail,
    SignableDocsHome,
} from '../../containers/SignableDocs'
import { WebsiteHome } from '../../containers/Website/WebsiteHome'
import {
    VoiceAgentHome,
    VoiceAgentSetupWizard,
    VoiceAgentSettings,
    VoiceAgentCalls,
    VoiceAgentCallDetail,
    PhoneRedirect,
} from '../../containers/VoiceAgent'
import { FinanceHome } from '../../containers/Finance/FinanceHome'

export const manageRoutes: RouteConfig[] = [
    {
        path: Routes.manage.propertyEvents.root,
        component: PropertyEventsHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.leasingSeason.campaigns.detail,
        component: SeasonCampaignDetail,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.leasingSeason.campaigns.create,
        component: SeasonCampaignCreate,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.leasingSeason.campaigns.root,
        component: SeasonCampaignsHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.leasingSeason.seasons,
        component: ManageSeasonsLanding,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.leasingSeason.root,
        component: LeasingSeasonHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.signableDocs.new,
        component: SignableDocsCreate,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.signableDocs.detail,
        component: SignableDocsDetail,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.signableDocs.root,
        component: SignableDocsHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.voiceAgent.callDetail,
        component: VoiceAgentCallDetail,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.voiceAgent.calls,
        component: VoiceAgentCalls,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.voiceAgent.setup,
        component: VoiceAgentSetupWizard,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.voiceAgent.settings,
        component: VoiceAgentSettings,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.voiceAgent.root,
        component: VoiceAgentHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.phone.root,
        component: PhoneRedirect,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.lease.root,
        component: LeaseHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.lease.auditDetail,
        component: LeaseAuditDetail,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.lease.audit,
        component: LeaseAuditHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.propertyAudit.root,
        component: PropertyAudit,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.rent.root,
        component: RentHome,
        // component: Payments,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.finance.root,
        component: FinanceHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        // More specific than prospects.root — must be registered first (RR v5 prefix match).
        path: Routes.manage.prospects.upload,
        component: SpreadsheetUploadPage,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.prospects.root,
        component: ProspectsHome,
        layout: ManageLayout,
        guard: ManageGuard,
        exact: true,
    },
    {
        path: Routes.manage.campaign.detail,
        component: CampaignDetail,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.campaign.root,
        component: CampaignHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.campaign.create,
        component: CreateCampaign,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.campaign.guestCards,
        component: GuestCardsPage,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.lead.root,
        component: LeadHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.webTools,
        component: WebToolsPage,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.contractManager,
        component: ContractManager,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.moveOutManagement,
        component: MoveOutManagement,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.concessions.root,
        component: ConcessionsHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.tenantMessages.root,
        component: TenantMessagesHome,
        layout: ManageLayout,
        guard: ManageGuard,
    },
    {
        path: Routes.manage.leasingSeasonConfig.detail,
        component: LeasingSeasonConfigEditorPage,
        layout: ManageLayout,
        guard: ManageGuard,
        exact: true,
    },
    {
        path: Routes.manage.leasingSeasonConfig.root,
        // Same tabbed shell as detail; Leads Pipeline tab hosts the chooser.
        component: LeasingSeasonConfigEditorPage,
        layout: ManageLayout,
        guard: ManageGuard,
        exact: true,
    },
    {
        path: Routes.manage.integrations,
        component: EzManageIntegrationsPage,
        layout: ManageLayout,
        guard: ManageGuard,
        exact: true,
    },
]
